import axiosInstance from "../api";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import {
  GET_FILTERD_RENTAL,
  GET_MINE_RENTAL_ORDER,
  GET_RENTAL,
  GET_RENTAL_BY_ID,
  GET_RENTAL_MINE,
  GET_RENTAL_ORDER,
  GET_RENTAL_REQUEST_BY_ID,
} from "../constants";
import { bxpAcceptReject, getBxpTogether1 } from "../ots/action";
import { getPostCounts } from "../posts/action";

export const getRentalList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`rental`);
    if (response?.data?.status) {
      dispatch({ type: GET_RENTAL, getrentallist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const FilterRentalListings = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("rental", data);
    if (response?.data?.status) {
      dispatch({ type: GET_FILTERD_RENTAL, getfilterdrental: response.data });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const getMineRentalList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`rental?is_mine=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_RENTAL_MINE,
        getminerentallist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addRental = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("rental/create", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getMineRentalList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateRental = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("rental/update", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getMineRentalList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const getRentalById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`rental/id?id=${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_RENTAL_BY_ID,
        getrentalbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addtowishRentalbyid = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`rental/id?id=${id}&wishlist=1`);
    if (response?.data?.status) {
      dispatch(getRentalById(id));
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};


export const deleteRental = (id, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`rental/delete?id=${id}`);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPostCounts(6));
      dispatch(getMineRentalList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const rentalRequestListings =
  (data, setModaltitle) => async (dispatch) => {
    try {
      const response = await axiosInstance.post("rental/request/create", data);
      if (response?.data?.status) {
        urtoast(response?.data?.response?.message, 1);
        if (setModaltitle) {
          setModaltitle(false);
        }
      } else {
        urtoast(response?.data?.response?.message, 2);
      }
    } catch (err) {
      console.error();
      //urtoast(err.message, 2);
    }
  };

export const getMineRentalOrderList = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `rental?is_mine=1&status=${status}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_MINE_RENTAL_ORDER,
        minerentalorderlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
export const getRentalOrderList = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`rental?status=${status}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_RENTAL_ORDER,
        rentalorderlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const rentalAcceptReject = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("rental/request/update", data);
    if (response?.data?.status) {
      dispatch(getBxpTogether1(1));
      dispatch(getPostCounts(7));
      urtoast(response?.data?.response?.message, 1);
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const getRentalRequestById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `rental/request/id?rental_request_id=${id}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_RENTAL_REQUEST_BY_ID,
        getrentalrequestbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const payRentalAmount = (data, navigate) => async (dispatch) => {
  try {
    const payload = { ...data, wallet: data?.wallet || 0 };
    const response = await axiosInstance.post("payment", payload);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      navigate(-2);
      dispatch(getRentalRequestById(data?.id));
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateRentalStatus = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("rental/request/update", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      dispatch(getRentalRequestById(data?.id));
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const rentalRequest =
  (data, setLoading, navigate) => async (dispatch) => {
    try {
      const response = await axiosInstance.put("rental/request/update", data);
      if (response?.data?.status) {
        urtoast(response?.data?.response?.message, 1);

        if (response?.data?.response) {
          setLoading(false);
          navigate(data?.url, {
            state: {
              orderdetails: {
                ...data?.state,
              },
            },
          });
          urtoast(response?.data?.response?.message, 1);
        }
      } else {
        urtoast(response?.data?.response?.message, 2);
      }
    } catch (err) {
      console.error();
      //urtoast(err.message, 2);
    }
  };

export const rentalPriceDetails = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("rental/request/create", data);
    if (response?.data?.status) {
      // urtoast(response?.data?.response?.message, 1);
    } else {
      // urtoast(response?.data?.response?.message, 2);
    }
    return response?.data?.response
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};
